import { FC, SVGProps } from 'react';

export const ODPLogoGray24px: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.99978 21.0004L16.0002 3.00044L19.0001 3.00077L7.99961 21.0004L4.99978 21.0004Z"
      fill="currentColor"
    />
  </svg>
);
